import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import agent from "../agent/agent";

const initialState = {
  user: null,
  isLoading: true,
};

export const fetchGetUser = createAsyncThunk('UserStore/fetchGetUser', async (_, { rejectWithValue }) => {
  const sessionId = localStorage.getItem('sessionId');
  if (!sessionId) {
    return rejectWithValue('Пользователь не найден');
  }

  const user = await agent.get(`/auth/session?session_id=${ sessionId }`)
    .then((res) => res.data?.data?.user || null).catch(() => null);
  if (!user) {
    localStorage.removeItem('sessionId');
    return rejectWithValue('Пользователь не найден');
  }

  return user
});
export const fetchLogOutUser = createAsyncThunk('UserStore/fetchLogOutUser', async (_, { rejectWithValue }) => {
  const sessionId = localStorage.getItem('sessionId');
  await agent.get(`/user/logout?session_id=${ sessionId }`).then((res) => null).catch(() => null);
  localStorage.removeItem('sessionId');
  window.location.reload();
  return null
});
export const UserStore = createSlice({
  name: 'UserStore',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchGetUser.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchGetUser.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
    builder.addCase(fetchGetUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
      });

    builder.addCase(fetchLogOutUser.pending, (state) => {
      state.isLoading = false;
      state.error = null;
    });
    builder.addCase(fetchLogOutUser.rejected, (state, action) => {
      state.isLoading = false;
      state.error = null;
    });
    builder.addCase(fetchLogOutUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = null;
      });
  }
});


export const {  } = UserStore.actions;
export default UserStore.reducer;
